module.exports = __webpack_public_path__ + "img/Daniels-Trace-Login-Button.f34c6a3b.svg";